import { isNil } from "./nil";
// export const cssStyleBlackOnLightblue = ["background: #e1edff", "color: black"].join(";");
// export const cssStyleGreyOnWhite = ["background: white", "color: #5b5b5b"].join(";");
export var cssStyleBlueOnWhite = ["background: white", "color: #0003d5"].join(";");
export var cssStyleGreenOnWhite = ["background: white", "color: #00830f"].join(";");
export var cssStyleRedOnWhite = ["background: white", "color: #9d0002"].join(";");
var logEnabled = false;
var lastLogMessage = undefined;
export function logTimePeriodDivider() {
    if (lastLogMessage !== undefined && (Date.now() - lastLogMessage) > 1500) {
        var dur = Math.round((Date.now() - lastLogMessage) / 1000);
        console.log("[RS] -------------------------------------------------- " + dur + "s");
    }
    lastLogMessage = Date.now();
}
export function defaultLogger(state, msg) {
    var isBrowser = !isNil(console["group"]);
    if (!isBrowser) {
        console.log("[RS] " + state.name + " {o=" + state.getSubscriberCount() + "} = " + state.value);
    }
    else {
        logTimePeriodDivider();
        var value = state.value;
        if (value !== undefined) {
            value = !isNil(value) ? value.toString() : value;
            console.log("%c[RS] " + state.name + " {o=" + state.getSubscriberCount() + "} %o", cssStyleGreenOnWhite, value);
        }
        else {
            console.log("%c[RS] " + state.name + " {o=" + state.getSubscriberCount() + "} %o", cssStyleRedOnWhite, value);
        }
    }
}
var logger = defaultLogger;
export function setLogger(loggerFn) {
    logger = loggerFn;
}
export function logStateChange(state, msg) {
    if (isLogEnabled() && !isNil(state.name)) {
        logger(state, msg);
    }
}
export function enableReactiveStatesLogging(enable) {
    if (enable === void 0) { enable = true; }
    logEnabled = enable;
}
export function isLogEnabled() {
    return logEnabled;
}
